import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT, CATEGORIES, scrollToId } from "../constants";
import { useLanguage } from "../i18n/LanguageContext";
import SocialIcons from "./SocialIcons";

const Footer = ({ onOpenCookies }) => {
  const { t } = useLanguage();

  return (
    <footer data-testid="main-footer" className="border-t border-gold/10 bg-[#060608]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-display text-2xl font-bold tracking-[0.08em] text-white">
              A<span className="text-gold-gradient">&amp;</span>A <span className="text-gold">MOTORS</span>
            </p>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.35em] text-gold">Car Rental Dubai</p>
            <p className="mt-5 text-sm leading-relaxed text-slate-400">{t("footer.desc")}</p>
            <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.25em] text-gold/70">{t("slogan")}</p>
          </div>

          <nav aria-label={t("footer.fleetTitle")}>
            <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-white">{t("footer.fleetTitle")}</h3>
            <ul className="mt-5 space-y-2.5">
              {CATEGORIES.map((cat) => (
                <li key={cat}>
                  <button
                    type="button"
                    data-testid={`footer-category-${cat}`}
                    onClick={() => scrollToId("fleet")}
                    className="text-sm text-slate-400 transition-colors hover:text-gold"
                  >
                    {t(`categories.${cat}`)}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-white">{t("footer.contactTitle")}</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={CONTACT.uaeTel} data-testid="footer-phone-uae" dir="ltr" className="flex items-center gap-2.5 text-slate-400 transition-colors hover:text-gold">
                  <Phone className="h-4 w-4 text-gold/70" aria-hidden="true" />
                  {CONTACT.uaeDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.deTel} data-testid="footer-phone-de" dir="ltr" className="flex items-center gap-2.5 text-slate-400 transition-colors hover:text-gold">
                  <Phone className="h-4 w-4 text-gold/70" aria-hidden="true" />
                  {CONTACT.deDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.whatsapp} data-testid="footer-whatsapp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-slate-400 transition-colors hover:text-[#25D366]">
                  <MessageCircle className="h-4 w-4 text-[#25D366]/80" aria-hidden="true" />
                  WhatsApp
                </a>
              </li>
              <li className="text-slate-500">Dubai, United Arab Emirates</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-white">{t("footer.legalTitle")}</h3>
            <ul className="mt-5 space-y-2.5 text-sm">
              <li><Link data-testid="footer-privacy" to="/legal/privacy" className="text-slate-400 transition-colors hover:text-gold">{t("footer.privacy")}</Link></li>
              <li><Link data-testid="footer-terms" to="/legal/terms" className="text-slate-400 transition-colors hover:text-gold">{t("footer.terms")}</Link></li>
              <li><Link data-testid="footer-impressum" to="/legal/impressum" className="text-slate-400 transition-colors hover:text-gold">{t("footer.impressum")}</Link></li>
              <li>
                <button type="button" data-testid="footer-cookies" onClick={onOpenCookies} className="text-slate-400 transition-colors hover:text-gold">
                  {t("footer.cookies")}
                </button>
              </li>
            </ul>
            <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-white">{t("footer.socialTitle")}</h3>
            <div className="mt-4">
              <SocialIcons />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/[0.06] pt-8 sm:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} A&amp;A MOTORS. {t("footer.rights")}</p>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold/60">{t("tagline")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
